import { useState } from "react";
import RequestTeamForm from "./RequestTeamForm";
import { Accordion, Button, Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";

export default function Teams() {
  const { t } = useTranslation("common");
  const [showInfo, setShowInfo] = useState(true);

  if (showInfo) {
    return (
      <Container style={{ maxWidth: "800px" }}>
        <h2>{t("teams.title")}</h2>
        <p>{t("teams.question")}</p>
        <p>{t("teams.channelInfo")}</p>
        <p>{t("teams.unsure")}</p>
        <div className="mb-3">
          <Accordion>
            <Accordion.Item eventKey="0">
              <Accordion.Header>
                {t("teams.accordionTitle")}
              </Accordion.Header>
              <Accordion.Body>
                <p>{t("teams.accordionIntro")}</p>
                <h4>{t("teams.teamsTitle")}</h4>
                <p>
                  <strong>{t("teams.teamsWhenLabel")}</strong> {t("teams.teamsWhenText")}
                </p>
                <p>
                  <strong>{t("teams.teamsWhatLabel")}</strong> {t("teams.teamsWhatText")}
                </p>
                <h4>{t("teams.channelsTitle")}</h4>
                <p>
                  <strong>{t("teams.channelsWhenLabel")}</strong> {t("teams.channelsWhenText")}
                </p>
                <p>
                  <strong>{t("teams.channelsWhatLabel")}</strong> {t("teams.channelsWhatText")}
                </p>
                <h4>{t("teams.groupChatTitle")}</h4>
                <p>
                  <strong>{t("teams.groupChatWhenLabel")}</strong> {t("teams.groupChatWhenText")}
                </p>
                <p>
                  <strong>{t("teams.groupChatWhatLabel")}</strong> {t("teams.groupChatWhatText")}
                </p>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
        <Button onClick={() => setShowInfo(false)}>
          {t("teams.needTeamButton")}
        </Button>{" "}
        {/* <Button variant="secondary" onClick={() => window.close()}>
          {t("teams.channelSufficient")}
        </Button> */}
      </Container>
    );
  }

  return (
    <div>
      <RequestTeamForm />
    </div>
  );
}
